<form [formGroup]="form" (submit)="onSubmit()">
  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Nome</mat-label>
      <input
        matInput
        type="text"
        placeholder="informe seu nome"
        formControlName="fullname"
      />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Sobrenome</mat-label>
      <input
        matInput
        type="text"
        placeholder="informe seu sobrenome"
        formControlName="lastname"
      />
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Sexo</mat-label>
      <mat-select
        matInput
        placeholder="Escolha o sexo"
        formControlName="gender"
      >
        <mat-option value="masculino">Masculino</mat-option>
        <mat-option value="feminino">Feminino</mat-option>
        <mat-option value="outros">Outros</mat-option>
        <mat-option value="none">Não prefiro informar</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('gender').errors?.required"
        >Por favor informe o sexo</mat-error
      >
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Celular/whatsapp</mat-label>
      <input
        type="text"
        placeholder="Seu telefone"
        matInput
        formControlName="phone"
        mask="(00) 00000 0000"
        inputmode="numeric"
      />
    </mat-form-field>

    <!-- <mat-form-field appearance="outline">
      <mat-label>CPF</mat-label>
      <input
        type="text"
        placeholder="seu CPF"
        matInput
        formControlName="taxDocumentNumber"
        mask="000.000.000-00"
        inputmode="numeric"
      />
    </mat-form-field> -->
  </div>

  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Senha</mat-label>
      <input
        matInput
        [type]="showPassword ? 'text' : 'password'"
        placeholder="Informe sua senha"
        formControlName="password"
      />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Confirmar senha</mat-label>
      <input
        matInput
        [type]="showPassword ? 'text' : 'password'"
        placeholder="Repita sua senha"
        formControlName="password2"
      />
    </mat-form-field>

    <button
      mat-icon-button
      color="primary"
      type="button"
      (click)="showPassword = !showPassword"
    >
      <mat-icon *ngIf="!showPassword">visibility</mat-icon>
      <mat-icon *ngIf="showPassword">visibility_off</mat-icon>
    </button>
  </div>
  <!-- <mat-progress-bar mode="indeterminate" color="primary" *ngIf="submiting"></mat-progress-bar> -->

  <div class="actions">
    <button
      mat-raised-button
      class="custom-primary"
      color="primary"
      type="submit"
      [disabled]="!form.valid"
      matStepperNext
    >
      Continuar
    </button>
  </div>
</form>
<iframe
  *ngIf="mauticFormSrc"
  [src]="mauticFormSrc"
  hidden
  frameborder="0"
></iframe>
